// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".shortTips-3sFsCJkD {\n    position: absolute;\n    left: 30px;\n    bottom: 76px;\n    width: 536px;\n    height: 56px;\n    font-size: 26px;\n    line-height: 56px;\n    text-align: center;\n    letter-spacing: 0.35px;\n    background: #000000;\n    border-radius: 30px;\n    text-align: center;\n    opacity: 0.8;\n    color: #FFF;\n}\n\n.fhxwkhd-ZLEa46xl {\n    color: #F54343;\n    font-size: 26px;\n    line-height: 56px;\n}", ""]);
// Exports
exports.locals = {
	"shortTips": "shortTips-3sFsCJkD",
	"fhxwkhd": "fhxwkhd-ZLEa46xl"
};
module.exports = exports;
